module.exports = __webpack_public_path__ + "img/Logo.1ffb8f34.png";